import React, { useState } from 'react';
import { Button } from 'antd';

import { ProfileCorporateInfoModel } from 'api/backofficeApiClient';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import { getCorporateTAPrimaryContactInfo } from 'redux/reducers/recruiterSlice';
import BaseSectionMessage from 'components/wrappers/BaseSectionMessage';
import BasePageCard from 'components/wrappers/BasePageCard';
import BaseAlert from 'components/wrappers/BaseAlert';
import PrimaryContactCard from 'features/account/AdditionalInfo/PrimaryContactInfo/PrimaryContactCard';
import EditPrimaryContactInfoModal from 'features/account/AdditionalInfo/PrimaryContactInfo/EditPrimaryContactInfoModal';
import { useAppDispatch } from 'hooks/useAppDispatch';

type Props = {
  corporateInfo?: ProfileCorporateInfoModel;
};

export default function PrimaryContactSection(props: Props) {
  const { corporateInfo } = props;
  const dispatch = useAppDispatch();
  const [primaryContactInfo, setPrimaryContactInfo] = useState(
    corporateInfo?.primaryContacts,
  );
  const [isModalVisible, setIsModalVisible] = useState(false);

  const loadPrimaryContactInfo = async () => {
    const result = await dispatch(
      getCorporateTAPrimaryContactInfo(corporateInfo?.companyId),
    );

    if (getCorporateTAPrimaryContactInfo.fulfilled.match(result)) {
      setPrimaryContactInfo(result.payload);
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      {isModalVisible && (
        <EditPrimaryContactInfoModal
          companyId={corporateInfo?.companyId}
          onClose={handleCloseModal}
          onEdit={loadPrimaryContactInfo}
          primaryContactInfo={primaryContactInfo}
        />
      )}

      <BasePageCard
        title="Primary contact information"
        className="stretch-card"
        icons={<span className="icon icon-contacts"></span>}
        subTitle={
          <Button
            onClick={handleOpenModal}
            className="with-icon mobile-icon-only"
            size="large"
            icon={<span className="icon icon-edit" />}
          >
            Edit
          </Button>
        }
      >
        <div className="scroll-box">
          {!primaryContactInfo?.length && (
            <div className="content-wrapper">
              <BaseSectionMessage
                type="info"
                title="Info"
                message={
                  <span>
                    Waiting for member to respond. Primary contact information
                    will be displayed after a member enters the data.
                  </span>
                }
              />
            </div>
          )}

          {!!primaryContactInfo?.length && (
            <>
              {primaryContactInfo.map((primaryContact, index) => (
                <PrimaryContactCard
                  key={index}
                  primaryContact={primaryContact}
                />
              ))}
            </>
          )}
        </div>
      </BasePageCard>
    </>
  );
}
